import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import FinanceLanding from './FinanceLanding'; // 首页组件
import ServicePage from './Services';
import ContactUs from './ContactUs';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 定义路径和组件的对应关系 */}
        <Route path="/" element={<FinanceLanding />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;